/**
 * Query param marking that the Cognito logout hop has already happened for
 * this landing, so SSOLandingPage must not hop again (see App bootstrap).
 */
export const FRESH_LOGIN_PARAM = 'freshLogin'
